import { THEME_COLOR, API_URL } from '../../constant';

import React, {useEffect, useState} from 'react';
import { useHistory } from "react-router";

import { useLocalStorage } from "../../useLocalStorage";

import toast, { Toaster } from 'react-hot-toast';
import "./Address.css";

let Address = (props)=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [addresses, setAddresses] = useState([]);
    let history = useHistory();

    function requestDefaultAddress(address){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("x-access-token", token);

        var urlencoded = new URLSearchParams();
        urlencoded.append("AddressID", address.ID);

        var requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/address`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    async function setDefaultAddress(address){
        let response = await requestDefaultAddress(address)

        if(response.status == 200){
            toast.success(response.message)
        }else{
            toast.error(response.message)
        }
    }

    function addAddress(){
        history.push('/address')
    }
    
    const changeIsOpenAddress = (val) => {
        props.changeIsOpenAddress(val)
    }

    function clickAddress(address){
        props.setAddress({
            ID: address.ID,
            Alias: address.Name,
            Name: "",
            Phone: address.MobilePhone,
            Address: address.Address,
            District: address.VillageName,
            City: address.CityName,
            Province: address.ProvinceName,
            ZipCode: address.ZipCode,
            Nation: address.CountryName,
            VillageID: address.VillageID,
            DistrictID: address.DistrictID,
            RegencyID: address.RegencyID,
            CityID: address.CityID,
            ProvinceID: address.ProvinceID,
            CountryID: address.CountryID
        })
        changeIsOpenAddress(false);
    }

    function getAdress(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/address`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    useEffect(async ()=>{
        let response = await getAdress();
        if(response.status == 200){
            setAddresses(response.data);
        } else{
            toast.error(response.message);
        }
    },[]);
    return (
        <>
            {/* <Toaster
                position="bottom-center"
            /> */}
            <div className='warehouse-container'>
                <div className="shipping-container">
                    {
                        addresses.map((address, index)=>{
                            return (
                                    // {/* <div className="detail-header">Warehouse</div> */}
                                    <div style={{marginBottom:"20px"}}>
                                    <div className="shipping-info-container" style={{padding:"10px"}}>
                                        <div className="shipping-information-header">{address.Name}</div>
                                        <div className="shipping-information-header">{address.MobilePhone}</div>
                                        <div></div>
                                        <div>{address.Address}, {address.VillageName}, {address.CityName}, {address.ProvinceName}, {address.CountryName}</div>
                                        <hr/>
                                        <div className="address-flex">
                                            <div className="" style={{flexGrow:1}}>
                                                {
                                                    <span style={{color:"#ee4d2d"}} onClick={()=> setDefaultAddress(address)}>set to default</span>
                                                }
                                            </div>
                                            <div className="right-align">
                                                {
                                                    <button className={`btn ${THEME_COLOR}`} onClick={()=> clickAddress(address)} >Select</button>
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
                <div className="expedition-flex" onClick={()=> {addAddress()}}>
                    <div className='expedition-name expedition-price'>Add New Address</div>
                </div>
            </div>
        </>
    );
}

export default Address;